import React, { useState } from 'react';
import Info from 'app/components/svgs/Info';
import Modal from 'app/components/modals/Modal';
import { PURE_WHITE } from 'app/constants/Colors';
import { createStyles } from 'app/utils/css';
import { recordize } from 'app/remote';
import request from 'app/utils/request';
import { getDeployInfo } from 'app/utils/api';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import AutoLoader from 'app/containers/state/AutoLoader';
import appConfig from 'app/config/client';

const { deployInfo } = appConfig;

const getDeployInfoEntity = () => request(getDeployInfo()).then(recordize);

const DevServerDetails = () => {
  const [expanded, setExpanded] = useState(false);
  const breakpoint = usePageBreakpoint();

  return (
    <Styles>
      {css => (
        <div className={css('buttonLabel')} tabIndex="0" onClick={() => setExpanded(true)}>
          <Info color="blue" size="16" />
          {breakpoint >= NumericBreakpoint.Wide && (
            <div className={css('buttonLabelText')}>
              &nbsp;
              {deployInfo.branch}
            </div>
          )}

          {expanded && (
            <Modal onClose={() => setExpanded(false)}>
              <AutoLoader load={getDeployInfoEntity} args={{}}>
                {({ isSuccess, isError, result }) => {
                  const deployInfoEntity = isSuccess
                    ? result
                    : isError
                    ? {
                      branch: 'ERROR LOADING DATA',
                      revision: 'ERROR LOADING DATA',
                      date: 'ERROR LOADING DATA',
                    }
                    : /* loading */ undefined;

                  return (
                    <div className={css('values')}>
                      <div className={css('varCell')}>Frontend Branch</div>
                      <div className={css('valueCell')}>{deployInfo.branch}</div>

                      <div className={css('varCell')}>Frontend Commit</div>
                      <div className={css('valueCell')}>{deployInfo.revision}</div>

                      <div className={css('varCell')}>Backend Branch</div>
                      <div className={css('valueCell')}>{deployInfoEntity && deployInfoEntity.branch}</div>

                      <div className={css('varCell')}>Backend Commit</div>
                      <div className={css('valueCell')}>{deployInfoEntity && deployInfoEntity.revision}</div>

                      <div className={css('varCell')}>Backend Release Date</div>
                      <div className={css('valueCell')}>{deployInfoEntity && deployInfoEntity.date}</div>
                    </div>
                  );
                }}
              </AutoLoader>
            </Modal>
          )}
        </div>
      )}
    </Styles>
  );
};

export default DevServerDetails;

const cellStyle = {
  margin: '5px 0',
  fontFamily: 'monospace',
};

const Styles = createStyles({
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '16px',
    padding: '0 5px',
    alignSelf: 'stretch',
    backgroundColor: PURE_WHITE,
  },
  buttonLabelText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexBasis: '0',
    minWidth: '0',
    flexGrow: 1,
    flexShrink: 1,
  },
  values: {
    padding: '20px 20px 0 20px',
  },
  varCell: cellStyle,
  valueCell: {
    ...cellStyle,
    padding: '3px',
    background: '#b7e300',
    border: '1px solid #5c7a00',
    marginBottom: '25px',
  },
});
